import { IFeedback } from '@framework/ui/Pages/Landing/Sections/Feedbacks';
import goldmanSachsLogo from '@framework/assets/customers/svg/goldmanSachs.svg';
import citibankLogo from '@framework/assets/customers/svg/citibank.svg';
import loandepotLogo from '@framework/assets/customers/svg/loanDepot.svg';
import creditSuisseLogo from '@framework/assets/customers/svg/creditSuisse.svg';
import firstkeyLogo from '@framework/assets/customers/svg/firstKey.svg';
import williamBlairLogo from '@framework/assets/customers/svg/williamBlair.svg';
import onemainLogo from '@framework/assets/customers/svg/oneMainFinancial.svg';
import crossRiverLogo from '@framework/assets/customers/svg/crossRiver.svg';
import bankOfAmericaLogo from '@framework/assets/customers/svg/bankOfAmerica.svg';
import piperSandlerLogo from '@framework/assets/customers/svg/piperSandler.svg';

export const feedbacksList: IFeedback[] = [
  {
    imageSrc: goldmanSachsLogo.src,
    imageWidth: 69,
    imageHeight: 30,
    imageAlt: 'Goldman Sachs',
    feedbackText: '“Thank you so much. Never had better service in my life. Thank you again!”',
    feedbackAuthor: 'Kaitlyn',
  },
  {
    imageSrc: citibankLogo.src,
    imageWidth: 47,
    imageHeight: 31,
    imageAlt: 'citibank',
    feedbackText: '“Thank you so much for all of your help with this transaction! We loved working with you and look forward to working together in following deals. Thank you again!"',
    feedbackAuthor: 'Adriana',
  },
  {
    imageSrc: loandepotLogo.src,
    imageWidth: 115,
    imageHeight: 23,
    imageAlt: 'loanDepot',
    feedbackText: '“Your team is always the best! I will never forget my Saturday morning fiasco when they completely saved me!”',
    feedbackAuthor: 'D.A.',
  },
  {
    imageSrc: goldmanSachsLogo.src,
    imageWidth: 69,
    imageHeight: 30,
    imageAlt: 'Goldman Sachs',
    feedbackText: '“I’m not just saying this but your customer service is some of the best I’ve ever seen in any space. We greatly value your teams responsiveness and the product you deliver.”',
    feedbackAuthor: 'Jeff',
  },
  {
    imageSrc: creditSuisseLogo.src,
    imageWidth: 115,
    imageHeight: 25,
    imageAlt: 'Credit Suisse',
    feedbackText: '“Our clients should be paying me to recommend your data room. It costs less, it’s faster and easier to use.”',
    feedbackAuthor: 'Hakim',
  },
  {
    imageSrc: firstkeyLogo.src,
    imageWidth: 96,
    imageHeight: 30,
    imageAlt: 'FirstKey',
    feedbackText: '“I’m so happy we switched!”',
    feedbackAuthor: 'T.D.',
  },
  {
    imageSrc: williamBlairLogo.src,
    imageWidth: 115,
    imageHeight: 19,
    imageAlt: 'WilliamBlair',
    feedbackText: '“The attention to detail and customer support and service impressed me a ton. The product has been great, super simple to use thus far and have found everything that I need very easily.”',
    feedbackAuthor: 'C.R',
  },
  {
    imageSrc: goldmanSachsLogo.src,
    imageWidth: 69,
    imageHeight: 30,
    imageAlt: 'Goldman Sachs',
    feedbackText: '“Thank you SO much! You guys are the best. This is why I recommend you for every deal."',
    feedbackAuthor: 'Stephanie',
  },
  {
    imageSrc: onemainLogo.src,
    imageWidth: 82,
    imageHeight: 30,
    imageAlt: 'OneMain Financial',
    feedbackText: '“I can’t believe how much progress you have made and how much you continue to innovate. Everything you do is valuable to us. Please give kudos to your team - I really mean it - this is great stuff.”',
    feedbackAuthor: 'D.S.',
  },
  {
    imageSrc: crossRiverLogo.src,
    imageWidth: 92,
    imageHeight: 30,
    imageAlt: 'cross river',
    feedbackText: '“Finsight customer service (as well as the platform itself) is top notch and we look forward to working together more.”',
    feedbackAuthor: 'Ryan',
  },
  {
    imageSrc: bankOfAmericaLogo.src,
    imageWidth: 115,
    imageHeight: 35,
    imageAlt: 'Bank Of America',
    feedbackText: '“Your team has the best customer service I’ve ever seen. Thank you so much!”',
    feedbackAuthor: 'Parul',
  },
  {
    imageSrc: piperSandlerLogo.src,
    imageWidth: 116,
    imageHeight: 30,
    imageAlt: 'Piper Sandler',
    feedbackText: '“DealVDR has offered exactly what we’ve needed at the most competitive price, alleviating considerable pain points for our team and our client.”',
    feedbackAuthor: 'PSC',
  },
];
